export interface DatePickerListener {
  onDateChanged(newDate: Date, helper: DatePickerHelper): any;
}

export class DatePickerHelper {
  constructor(
    public listener: DatePickerListener = null!,
    public selectedDate: Date = new Date()
  ) {
    this.listener = listener;
  }

  setDate(newDate: Date) {
    this.selectedDate = newDate;
    this.notify();
  }

  getDate(): Date {
    return this.selectedDate;
  }

  nextDate() {
    this.selectedDate = this.addDays(this.selectedDate, 1);
    this.notify();
  }

  previousDate() {
    this.selectedDate = this.addDays(this.selectedDate, -1);
    this.notify();
  }

  private notify() {
    if (this.listener) {
      this.listener.onDateChanged(this.selectedDate, this);
    }
  }

  private addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
}
